"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("firebase/app"));
require("firebase/firestore");
require("firebase/auth");
var domain_1 = require("./types/domain");
function upsertUser(user) {
    return __awaiter(this, void 0, void 0, function () {
        var db, getSnapshot, doc, userUpdate, rolesSnapshot, doc_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    db = app_1.default.firestore();
                    return [4 /*yield*/, db.collection('users').doc(user.uid).get()];
                case 1:
                    getSnapshot = _a.sent();
                    doc = getSnapshot.data();
                    if (!doc) return [3 /*break*/, 4];
                    userUpdate = {
                        lastLogin: new Date().toISOString(),
                        email: user.email
                    };
                    return [4 /*yield*/, db.collection('users').doc(user.uid).update(userUpdate)]; // update server document with time
                case 2:
                    _a.sent(); // update server document with time
                    return [4 /*yield*/, db.collection('roles').doc(user.uid).get()];
                case 3:
                    rolesSnapshot = _a.sent();
                    return [2 /*return*/, Object.assign(doc, { roles: rolesSnapshot.data() || {} })];
                case 4:
                    doc_1 = {
                        uid: user.uid,
                        name: user.displayName || user.uid,
                        lastLogin: new Date().toISOString(),
                        email: user.email || '',
                        radar: ''
                    };
                    return [4 /*yield*/, db.collection('users').doc(user.uid).set(doc_1)];
                case 5:
                    _a.sent();
                    return [2 /*return*/, Object.assign(doc_1, { roles: {} })];
            }
        });
    });
}
function upsertRadar(user, appConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var db, getSnapshot, radarId, doc, setSnapshot;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!user.radar) return [3 /*break*/, 7];
                    db = app_1.default.firestore();
                    return [4 /*yield*/, db.collection('radars')
                            .where('owner', '==', user.uid)
                            .limit(3)
                            .get()];
                case 1:
                    getSnapshot = _a.sent();
                    radarId = void 0;
                    if (!getSnapshot.empty) return [3 /*break*/, 4];
                    console.log('No radar found for this user; creating one..'); // eslint-disable-line no-console
                    doc = {
                        title: user.name + "'s devradar",
                        categories: appConfig.radarDefault.categories,
                        levels: appConfig.radarDefault.levels,
                        owner: user.uid,
                        readers: [],
                        isPublic: appConfig.radarDefault.isPublic || false
                    };
                    return [4 /*yield*/, db.collection('radars').add(doc)];
                case 2:
                    setSnapshot = _a.sent();
                    return [4 /*yield*/, db.collection('users').doc(user.uid).update({ radar: setSnapshot.id })];
                case 3:
                    _a.sent();
                    radarId = setSnapshot.id;
                    return [3 /*break*/, 6];
                case 4:
                    // set the first radar to the active radar
                    radarId = getSnapshot.docChanges()[0].doc.id;
                    return [4 /*yield*/, db.collection('users').doc(user.uid).update({ radar: radarId })];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6: return [2 /*return*/, radarId];
                case 7: 
                // check if alias exists
                return [2 /*return*/, user.radar];
            }
        });
    });
}
function init(store, router, appConfig) {
    return __awaiter(this, void 0, void 0, function () {
        var app;
        var _this = this;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!appConfig.backend.project || !appConfig.backend.key) {
                        console.error('Misconfigured backend, please provide backend.project and backend.key'); // eslint-disable-line no-console
                        return [2 /*return*/, Promise.reject(new Error('Misconfigured backend, please provide backend.project and backend.key'))];
                    }
                    app = app_1.default.initializeApp({
                        apiKey: appConfig.backend.key,
                        authDomain: appConfig.backend.authDomain || appConfig.backend.project + ".firebaseapp.com",
                        databaseURL: "https://" + appConfig.backend.project + ".firebaseio.com",
                        projectId: "" + appConfig.backend.project
                    });
                    if (appConfig.isUnderTest) {
                        console.info('Disabling auth persistance'); // eslint-disable-line no-console
                        app_1.default.auth().setPersistence(app_1.default.auth.Auth.Persistence.NONE); // disable auth cache in test mode
                    }
                    else {
                        console.info('Setting auth persistance'); // eslint-disable-line no-console
                        app_1.default.auth().setPersistence(app_1.default.auth.Auth.Persistence.LOCAL); // store user until logout happens
                    }
                    store.commit('user/setLoginState', domain_1.LoginState.UNKNOWN);
                    store.commit('blips/setLoading', true);
                    // resolve after auth status is defined as logged in or not
                    return [4 /*yield*/, app_1.default.auth().onAuthStateChanged(function (oauthUser) { return __awaiter(_this, void 0, void 0, function () {
                            var user, radarId, radarIdOrAlias;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        store.commit('user/setLoginState', domain_1.LoginState.LOGIN_PENDING);
                                        store.commit('blips/setLoading', true);
                                        if (!oauthUser) return [3 /*break*/, 5];
                                        return [4 /*yield*/, upsertUser(oauthUser)];
                                    case 1:
                                        user = _a.sent();
                                        return [4 /*yield*/, upsertRadar(user, appConfig)];
                                    case 2:
                                        radarId = _a.sent();
                                        user.radar = radarId;
                                        store.commit('user/setUser', user);
                                        store.commit('user/setLoginState', domain_1.LoginState.LOGGED_IN);
                                        if (!!['radar', 'history'].includes(router.currentRoute.name)) return [3 /*break*/, 4];
                                        radarIdOrAlias = radarId;
                                        if (store.getters['blips/radarAlias']) {
                                            radarIdOrAlias = store.getters['blips/radarAlias'];
                                        }
                                        return [4 /*yield*/, store.dispatch('blips/getRadarLazy', radarIdOrAlias)];
                                    case 3:
                                        _a.sent();
                                        _a.label = 4;
                                    case 4:
                                        store.dispatch('intro/event', 'login');
                                        store.commit('blips/setLoading', false);
                                        return [2 /*return*/, user];
                                    case 5:
                                        store.commit('user/setLoginState', domain_1.LoginState.LOGGED_OUT);
                                        store.commit('blips/setLoading', false);
                                        store.commit('user/reset');
                                        return [2 /*return*/, {}];
                                }
                            });
                        }); })];
                case 1:
                    // resolve after auth status is defined as logged in or not
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.default = init;
